var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNearMe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.444,
    height: 49.394,
    viewBox: "0 0 40.444 49.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.744 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.96a7.96,7.96,0,1,1,7.96,7.96A7.96,7.96,0,0,1,0,7.96Z",
    transform: "translate(13.005 13.359)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.221,49.394a4.726,4.726,0,0,1-3.672-1.741L4.811,33.3A21.175,21.175,0,0,1,.073,18.069,19.684,19.684,0,0,1,19.692,0H20.75A19.687,19.687,0,0,1,40.371,18.069,21.2,21.2,0,0,1,35.634,33.3L23.893,47.653A4.726,4.726,0,0,1,20.221,49.394Zm0-40.209A11.633,11.633,0,1,0,31.855,20.818,11.647,11.647,0,0,0,20.221,9.185Z",
    transform: "translate(0.744 0.5)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearMe);
export default __webpack_public_path__ + "static/media/near-me.3e7b735465ec74450b8ea7b0ab653ca5.svg";
export { ForwardRef as ReactComponent };